import { Component, OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Options, ChangeContext } from 'ng5-slider';
import { PasswordPolicy } from 'src/app/model/passwordPolicy.modals';
import { PasswordPolicyService } from 'src/app/services/password-policy.service';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-password-protection-policy',
	templateUrl: './password-protection-policy.component.html',
	styleUrls: [ './password-protection-policy.component.css' ]
})
export class PasswordProtectionPolicyComponent implements OnInit, AfterViewInit,AfterViewChecked {
	strengthLevels: any[] = [
		{ text: 'Poor', class: ' label text-center label-danger' },
		{ text: 'Fair', class: 'label text-center label-warning' },
		{ text: 'Good', class: 'label text-center label-info' },
		{ text: 'Strong', class: 'label text-center label-primary' },
		{ text: 'Excellent', class: 'label text-center label-success' }
	];
	isUpdate: boolean = false;
	orgId: any = null;
	pwdStrength= { text: null, class: null };
	passwordPolicyModal: PasswordPolicy = null;
	isprocessing: boolean = false;
	passwordError: any = { isError: false, errorMessage: '' };
	options: Options = {
		showTicksValues: true,
		showTicks: false,
		stepsArray: [
			{ value: 1, legend: 'Non-empty required' },
			{ value: 2, legend: ' <div class=" inline pwd-length"></div>  characters atleast in length' },
			{ value: 3, legend: 'Lowercase,uppercase,numbers' },
			{ value: 4, legend: 'Special characters(!@#$%)' },
			{ value: 5, legend: 'No more than 2 identical chars in a row' }
		],
		ticksTooltip: (value) => {
			return this.strengthLevels[value]['text'];
		},
		vertical: true
	};
	hasSubmit: boolean = false;
  formToShow: string = 'form1';
  isLoading:boolean
  isSavingData:boolean=false;
	constructor(
		private activatedRoute: ActivatedRoute,
		private passwordPolicyService: PasswordPolicyService,
		private alertService: AlertService,
		private router: Router
	) {
		this.pwdStrength = this.strengthLevels[0];
		this.orgId = localStorage.getItem("org_id");
	}

	ngOnInit() {
		localStorage.setItem('option', 'security');
		this.passwordPolicyModal = new PasswordPolicy();
    this.passwordPolicyModal.passwordStrengthLevel = 0;
    this.passwordPolicyModal.org_id = this.orgId;
    // this.isLoading=true
		this.passwordPolicyService.getPasswordPolicyDetails(this.orgId).subscribe((response) => {
			if (response != null) {
				this.passwordPolicyModal.map(response as PasswordPolicy);
        this.isUpdate = true;
        let level=response['strengthLevel'];
				this.pwdStrength = this.strengthLevels[level==0?0:level-1];
				$('.input-length').val(
					this.passwordPolicyModal.regexValidators.length >= 2
						? this.passwordPolicyModal.regexValidators[1].value.match(/\d+/)
						: this.passwordPolicyModal.minPasswordLengthAllowed
				);
			} else {
				this.passwordPolicyModal.org_id = this.orgId;
				$('.input-length').val(this.passwordPolicyModal.minPasswordLengthAllowed);
      }
      // this.isLoading=false
    }),
    (err)=>{this.isLoading=false}
	}
	ngAfterViewInit() {
    $('.pwd-length').append("<div style='width: 70px;visibility:hidden'/>");
    $('.input-length').val(this.passwordPolicyModal.minPasswordLengthAllowed);
  }
  ngAfterViewChecked(){
     let elements=document.getElementsByClassName('input-length');
    if(elements.length>0)
   {
     let value= (<HTMLInputElement>elements[0]).value
      $('.input-length').val(parseInt(value)?value:this.passwordPolicyModal.minPasswordLengthAllowed);
  }

  }
	onUserChangeEnd(changeContext: ChangeContext): void {
		this.pwdStrength = this.strengthLevels[changeContext.value - 1];
	}

	savePasswordPolicy(formPasswordPolicy: NgForm, formProtection: NgForm, formAppPolicy: NgForm) {
		this.hasSubmit = true;
		if (!formPasswordPolicy.valid) {
			document.getElementById('tab2').click();
			return;
		} else if (!formProtection.valid) {
			document.getElementById('tab1').click();
			return;
		} else if (!formAppPolicy.valid) {
			document.getElementById('tab3').click();
			return;
		} else {
      this.isSavingData=true
			if (this.isUpdate)
				this.passwordPolicyService.updatePasswordPolicy(this.passwordPolicyModal).subscribe(
					(response) => {
            this.isSavingData=false
						this.alertService.updateAlert(response['message']);
					},
					(error) => {this.isSavingData=false}
				);
			else
				this.passwordPolicyService.savePasswordPolicy(this.passwordPolicyModal).subscribe(
					(response) => {
						this.alertService.updateAlert(response['message']);
            this.isUpdate = true;
            this.isSavingData=false
					},
					(error) => {this.isSavingData=false}
				);
			localStorage.setItem('passwordPolicy', JSON.stringify(this.passwordPolicyModal));
		}
  }

 /**
  * To trigger the validation of max password policy field
  * @param {*} maxPasswordReference
  * @memberof PasswordProtectionPolicyComponent
  */
 triggerMaxPasswordValidation(maxPasswordReference) {
		if (this.passwordPolicyModal.minimumPasswordLifeCycle >= 0)
			maxPasswordReference.control.updateValueAndValidity();
	}
 /**
  * To trigger the validation of min password policy field
  * @param {*} minPasswordReference
  * @memberof PasswordProtectionPolicyComponent
  */
 triggerMinPasswordValidation(minPasswordReference) {
		if (this.passwordPolicyModal.maximiumPasswordLifeCycle >= 0)
			minPasswordReference.control.updateValueAndValidity();
	}
}
export class PwdStrength {
	constructor() {}
	text: string;
	class: string;
}
